import { render, staticRenderFns } from "./CopyInstance.vue?vue&type=template&id=68ffe68b&scoped=true&"
import script from "./CopyInstance.vue?vue&type=script&lang=js&"
export * from "./CopyInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ffe68b",
  null
  
)

export default component.exports